import Link from "@mui/material/Link";
import PropTypes from "prop-types";
import { Link as RouterLink } from "react-router-dom";
import { withAppPlatformQuery } from "../../config/appWebViewLegal";

/** Internal legal link that preserves ?platform=app for iOS in-app WebView sessions. */
export default function LegalAppLink({ to, children, ...rest }) {
    return (
        <Link component={RouterLink} to={withAppPlatformQuery(to)} {...rest}>
            {children}
        </Link>
    );
}

LegalAppLink.propTypes = {
    to: PropTypes.string.isRequired,
    children: PropTypes.node,
};
